import React, { Component } from 'react'

class Select extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  render () {
    const { fieldData } = this.props
    const { id, name, selectedValue } = fieldData
    const options = fieldData.options.map((data, i) => {
      return {...data, key: i}
    })
    const onChange = fieldData.onChange ? fieldData.onChange : this.handleChange
    return (
      <div className='select'>
        <select
          name={name}
          id={id}
          value={selectedValue}
          onChange={onChange}
        >
          {options.map(data => <option key={data.key} value={data.value} >{data.name}</option>)}
        </select>
      </div>
    )
  }

  handleChange (event) {
    const { fieldData, store } = this.props
    const { name } = fieldData
    store.handleChange(event.target.value, name)
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/components/generic/Select.js